import React from 'react';
import Panel from './Panel';
import { CHANNELS } from '../utils/channelInventory';
import { controlFor } from '../utils/channelControlApi';
import ChannelStatusRow from './ChannelStatusRow';
import { openChannels } from '../utils/channelsLaunch';

/**
 * The narrow Channel Status panel that sits to the left of Staged.
 *
 * It shows every channel the platform plans to carry, active or not, with a
 * health light and the channel's own icon. The icon opens the Channels context;
 * its top Bindings command is the sole manager entry and defaults to Email.
 * This replaces the Channel Status dropdown that used to live in the toolbar.
 */
export default function ChannelStatusPanel({ style, onError, controls = null, error = '' }) {
    const openChannelsContext = () => {
        openChannels().catch(err => {
            console.error('Open Channels failed:', err);
            onError?.(err.message || 'The Channels screen could not be opened.');
        });
    };

    return (
        <Panel
            title="Channel Status"
            style={{ height: '100%', boxSizing: 'border-box', ...style }}
            bodyStyle={{ padding: '4px 10px', overflowY: 'auto' }}
        >
            <div>
                {error && (
                    <div style={{ padding: '4px 0', color: 'var(--color-text-secondary)', fontSize: 11 }}>
                        Enablement unavailable; production sending is blocked.
                    </div>
                )}
                {CHANNELS.map(ch => (
                    <ChannelStatusRow
                        key={ch.id}
                        channel={ch}
                        // controlFor translates the inventory token to the name
                        // the server files the record under (browser → email).
                        // A raw lookup by token misses that record, and a
                        // missing record renders as Failed.
                        control={controlFor(controls, ch.token)}
                        onOpenBindings={openChannelsContext}
                    />
                ))}
            </div>
        </Panel>
    );
}
